import { Spinner } from "@components/atoms/Spinner"
import { Button } from "@components/controls/Button"
import { AnimatePresence, motion, useInView } from "framer-motion"
import { useEffect, useRef, useState } from "react"

type Props = {
  onSensed(): void
  delay: number
  loading?: boolean
}

export function LoadingSensor(props: Props) {
  const ref = useRef<HTMLDivElement>(null)
  const inView = useInView(ref)
  const label = "Loading more..."
  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    if (!props.loading && inView && !disabled) {
      let timer = setTimeout(() => {
        setDisabled(true)
        props.onSensed()
      }, props.delay)
      return () => clearTimeout(timer)
    }
  }, [inView, props.loading, disabled])

  useEffect(() => {
    if (!props.loading) {
      setDisabled(true)
      let timer = setTimeout(() => {
        setDisabled(false)
      }, 400)
      return () => clearTimeout(timer)
    }
  }, [props.loading])

  const spinning = props.loading || disabled

  return (
    <div className="w-full py-6 items-center justify-center stack-y-0">
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={spinning ? "loading" : "sensing"}
          className="size-button items-center justify-center flex"
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0 }}
          initial={{ opacity: 0, scale: 0 }}
        >
          {spinning ? (
            <Spinner className="text-black" />
          ) : (
            <svg version="1.1" viewBox="0 0 32 32" preserveAspectRatio="none">
              <circle
                cx="16"
                cy="16"
                r="6"
                id="green-halo"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeDasharray={inView ? "70,20000" : "0,20000"}
                style={
                  inView
                    ? {
                        transition: `all ${props.delay}ms linear`,
                      }
                    : {}
                }
              />
            </svg>
          )}
        </motion.div>
      </AnimatePresence>
      <div ref={ref} className="type-body-s-roman">
        {label}
      </div>
    </div>
  )
}
